var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 47,
    fill: "none",
    viewBox: "0 0 38 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 40.141L29.413 29.83c2.039-2.04 3.428-4.638 3.99-7.467.563-2.83.274-5.761-.83-8.426S29.6 8.994 27.202 7.392c-2.398-1.603-5.218-2.458-8.102-2.458-2.884 0-5.704.855-8.102 2.458-2.398 1.602-4.267 3.88-5.371 6.544-1.104 2.665-1.393 5.597-.83 8.426.562 2.829 1.951 5.427 3.99 7.467L19.1 40.14zm0 5.892L5.842 32.775C3.22 30.152 1.434 26.81.71 23.175c-.723-3.638-.352-7.408 1.067-10.834C3.197 8.915 5.6 5.987 8.683 3.926 11.767 1.866 15.392.766 19.1.766s7.334 1.1 10.417 3.16 5.487 4.989 6.906 8.415c1.419 3.426 1.79 7.196 1.067 10.833-.724 3.637-2.51 6.978-5.132 9.6L19.1 46.034zm0-22.35c1.105 0 2.165-.44 2.946-1.22.782-.782 1.22-1.842 1.22-2.947s-.438-2.165-1.22-2.946c-.781-.781-1.84-1.22-2.946-1.22-1.105 0-2.165.439-2.946 1.22-.782.781-1.22 1.841-1.22 2.946 0 1.105.438 2.165 1.22 2.946.781.782 1.841 1.22 2.946 1.22zm0 4.166c-2.21 0-4.33-.878-5.893-2.44-1.562-1.563-2.44-3.683-2.44-5.893s.878-4.33 2.44-5.892c1.563-1.563 3.683-2.441 5.893-2.441s4.33.878 5.893 2.44c1.563 1.563 2.44 3.683 2.44 5.893s-.878 4.33-2.44 5.893c-1.563 1.563-3.683 2.44-5.893 2.44z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.8a762480ea7777f4709ded4f8d16eac2.svg";
export { ForwardRef as ReactComponent };